import { render } from "./SelfServicePreOffers.vue.ts?vue&type=template&id=be505327&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SelfServicePreOffers.vue?vue&type=template&id=be505327&scoped=true&ts=true"
import script from "./SelfServicePreOffers.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SelfServicePreOffers.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelfServicePreOffers.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SelfServicePreOffers.vue?vue&type=script&setup=true&lang=ts"

import "./SelfServicePreOffers.vue.scss?vue&type=style&index=0&id=be505327&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SelfServicePreOffers.vue?vue&type=style&index=0&id=be505327&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be505327"],['__file',"src/apps/merchant3/components/self-onboarding/offers/SelfServicePreOffers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be505327"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be505327', __exports__)) {
    api.reload('be505327', __exports__)
  }
  
  module.hot.accept("./SelfServicePreOffers.vue.ts?vue&type=template&id=be505327&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SelfServicePreOffers.vue?vue&type=template&id=be505327&scoped=true&ts=true", () => {
    api.rerender('be505327', render)
  })

}


export default __exports__